import { render } from "./selectCofreNewDocument.vue?vue&type=template&id=087f9237&scoped=true&ts=true"
import script from "./selectCofreNewDocument.vue?vue&type=script&lang=ts"
export * from "./selectCofreNewDocument.vue?vue&type=script&lang=ts"

import "./selectCofreNewDocument.vue?vue&type=style&index=0&id=087f9237&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087f9237"]])

export default __exports__